<template>
	<div @click="refocus" class="tag-input">
		<span v-for="(tag, index) in tags" :key="index" class="tag-input__tag">
			<span>{{ tag }}</span>
			<a @click="remove(index)" class="tag-input__remove" />
		</span>

		<input type="text" v-model="newTag" ref="input"
			:placeholder="placeholder"
			v-on:keydown="keydown"
			v-on:blur="keydown"
			v-on:keydown.delete="keydownDelete"
			:maxlength="tagMaxLength"
			class="tag-input__input" />
	</div>
</template>

<script>
	export default {
		name: 'TagInput',
		props: {
			tags: {
				type: Array,
				default: () => []
			},
			placeholder: {
				type: String,
				default: ''
			}
		},
		data () {
			return {
				newTag: '',
				tagMaxLength: Grabcad.AttributeLimits.Generic.TAG
			}
		},
		computed: {
			splitTags () {
				return this.newTag.split(/[,;]+/).filter(Boolean)
			}
		},
		methods: {
			refocus () {
				this.$refs.input.focus()
			},

			remove (index) {
				this.tags.splice(index, 1)
			},
			keydownDelete () {
				if (this.newTag) { return }
				this.tags.pop()
			},
			keydown (event) {
				if (event.type === 'blur' || ['Enter', 'Tab', 'Comma', 'Semicolon'].includes(event.code)) {
					if (this.newTag) {
						event.preventDefault()
						this.tags.push(...this.splitTags)
						this.newTag = ''
					}
				}
			}
		}
	}
</script>

<style lang="scss">
	@import "@/styles/tutorial_editor/globals";

	.tag-input {
		padding: 7px;
		min-height: 40px;
		background: $white;
		border: solid 1px $light-gray-alt;
		border-radius: $tutorial-editor-border-radius;

		&__input {
			border: none;
			outline: none;
			font-size: .875em;
		}

		&__tag {
			border-radius: $tutorial-editor-border-radius;
			background-color: $blue-alt;
			display: inline-block;
			margin-right: 5px;
			padding: 3px 5px;
			font-size: .75em;
			cursor: pointer;
			color: $white;
			&:nth-child(n+9) {
				&, &:hover {
					background-color: $red;
				}
			}
		}

		&__tag:hover { background-color: $tutorial-editor-dark-blue; }
		&__remove::before { content:"\00d7"; }
	}
</style>
